import { TenantSubscription } from '../../entities/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';


export enum SalesSecurityRight {
    CanAccessOpportunities = 23000,
    ManageOpportunities = 23001,

    CanCreateOpportunityViews = 23010,
    ManageOtherUsersOpportunityViews = 23011,
    MarkOpportunities = 23012,
    DeleteOpportunity = 23013,

    CanAccessLeads = 23100,
    ManageLeads = 23101,
    CanCreateLeadViews = 23110,
    ManageOtherUsersLeadViews = 23111,
}

export class SalesSecurityModule extends BaseSecurityModule<SalesSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Sales,
            [
                { _id: SalesSecurityRight.CanAccessOpportunities, name: 'Access: Opportunities', basic: true },
                { _id: SalesSecurityRight.ManageOpportunities, name: 'Manage: Opportunities', basic: true },


                { _id: SalesSecurityRight.CanAccessLeads, name: 'Access: Leads', basic: true },
                { _id: SalesSecurityRight.ManageLeads, name: 'Manage: Leads', basic: true },


                { _id: SalesSecurityRight.CanCreateOpportunityViews, name: 'Can Create Opportunity Views', basic: false },
                { _id: SalesSecurityRight.ManageOtherUsersOpportunityViews, name: 'Can Manage Other User Opportunity Views', basic: false },
                { _id: SalesSecurityRight.MarkOpportunities, name: 'Mark Opportunities Won/Lost', basic: false },
                { _id: SalesSecurityRight.DeleteOpportunity, name: 'Delete Opportunity', basic: false },

                { _id: SalesSecurityRight.CanCreateLeadViews, name: 'Can Create Lead Views', basic: false },
                { _id: SalesSecurityRight.ManageOtherUsersLeadViews, name: 'Can Manage Other User Lead Views', basic: false },

            ] as SecurityRight<SalesSecurityRight>[]
        );

        this.plan = TenantSubscription.Professional;
    }


}
